import { GET, POST, PATCH, DELETE, POST_FORM } from "../config";

export const create = async (data) => {
  const response = await POST("inventory/products/", data);
  return response.data;
};

export const list = async (page = 1, filters = {}) => {
  let url = `inventory/products/?page=${page}`;

  // Agregar tamaño de página para obtener más resultados
  url += `&page_size=50`;

  if (filters.search) {
    url += `&name__icontains=${filters.search}`;
  }

  if (filters.category) {
    url += `&category=${filters.category}`;
  }

  if (filters.branch) {
    if (Array.isArray(filters.branch)) {
      // Para múltiples sucursales, usar branch__in con valores separados por coma
      url += `&branch__in=${filters.branch.join(",")}`;
    } else {
      // Para una sola sucursal
      url += `&branch=${filters.branch}`;
    }
  }

  if (filters.code) {
    url += `&code__icontains=${filters.code}`;
  }

  // Filtrar por tipo de producto si se especifica
  // ✅ CORREGIDO: Manejar arrays de tipos de producto correctamente
  // Django Filter espera valores separados por comas en un solo parámetro para filtros __in
  if (filters.product_type) {
    if (Array.isArray(filters.product_type)) {
      // Si es un array, usar product_type__in con valores separados por comas
      url += `&product_type__in=${filters.product_type.join(",")}`;
    } else {
      // Si es un string simple, usar product_type normal
      url += `&product_type=${encodeURIComponent(filters.product_type)}`;
    }
  }

  // Filtrar por productos con/sin stock
  if (filters.has_stock !== undefined) {
    if (filters.has_stock) {
      url += `&quantity__gt=0`;
    } else {
      url += `&quantity=0`;
    }
  }

  // Excluir tipos de productos específicos
  if (filters.exclude_product_type) {
    url += `&exclude_product_type=${encodeURIComponent(filters.exclude_product_type)}`;
  }

  console.log("Products API URL:", url);

  const response = await GET(url);
  console.log("[LIST] Products API response:", response.data);
  return response.data;
};

export const update = async (id, data) => {
  const response = await PATCH(`inventory/products/${id}/`, data);
  return response.data;
};

export const destroy = async (id) => {
  const response = await DELETE(`inventory/products/${id}/`);
  return response.data;
};

const create_category = async (data) => {
  const response = await POST("inventory/categories/", data);
  return response.data;
};

const list_category = async (page = 1, pageSize = 10) => {
  const url = `inventory/categories/?page=${page}&page_size=${pageSize}`;
  console.log("Categories API URL:", url);
  const response = await GET(url);
  console.log(" Categories API Response:", response.data);
  return response.data;
};

const update_category = async (id, data) => {
  const response = await PATCH(`inventory/categories/${id}/`, data);
  return response.data;
};

const destroy_category = async (id) => {
  const response = await DELETE(`inventory/categories/${id}/`);
  return response.data;
};

/**
 * Obtener productos por tipo usando el nuevo endpoint
 */
export const getByType = async ({
  product_type,
  branch = null,
  search = "",
  page = 1,
} = {}) => {
  const params = new URLSearchParams();
  params.append("product_type", product_type);
  params.append("page", page);

  if (branch) params.append("branch", branch);
  if (search) params.append("search", search);

  const response = await GET(
    `inventory/products/by-type/?${params.toString()}`
  );
  return response.data;
};

/**
 * Obtener productos para cotizaciones
 * Incluye: SUPPLIER_PRODUCT, DIRECT_SALE, RECIPE_BASED
 * Excluye: MEASUREMENT_MATERIAL (materias de medición), CERTIFICATE, TOOL_EQUIPMENT
 */
export const getForQuotations = async ({
  branch = null,
  search = "",
  page = 1,
} = {}) => {
  // Por ahora usamos SUPPLIER_PRODUCT como principal para cotizaciones
  return await getByType({
    product_type: "SUPPLIER_PRODUCT",
    branch,
    search,
    page,
  });
};

/**
 * Obtener productos tipo SUPPLIER_PRODUCT
 * Productos de proveedores para cotizaciones
 */
export const getSupplierProducts = async ({
  branch = null,
  search = "",
  page = 1,
} = {}) => {
  return await getByType({
    product_type: "SUPPLIER_PRODUCT",
    branch,
    search,
    page,
  });
};

/**
 * Obtener productos tipo CERTIFICATE
 * Certificados digitales descargables
 */
export const getCertificateProducts = async ({
  branch = null,
  search = "",
  page = 1,
} = {}) => {
  return await getByType({ product_type: "CERTIFICATE", branch, search, page });
};

/**
 * Obtener materias de medición (APR)
 * Productos de tipo MEASUREMENT_MATERIAL para gestión de mediciones
 * 
 * @param {Object} options - Opciones de filtrado
 * @param {number|null} options.branch - ID de la sucursal para filtrar productos (IMPORTANTE: siempre filtrar por sucursal)
 * @param {string} options.search - Búsqueda por nombre o código
 * @param {number} options.page - Número de página
 * @returns {Promise<Object>} Lista de productos de tipo MEASUREMENT_MATERIAL
 * 
 * @example
 * // Obtener materias de medición de una sucursal específica
 * const materias = await api.products.getMeasurementMaterials({ branch: 3 });
 */
export const getMeasurementMaterials = async ({
  branch = null,
  search = "",
  page = 1,
  page_size = 100,
} = {}) => {
  const params = new URLSearchParams();
  params.append("product_type", "MEASUREMENT_MATERIAL");
  params.append("page", page);
  params.append("page_size", page_size);

  if (branch) params.append("branch", branch);
  if (search) params.append("search", search);

  const response = await GET(
    `inventory/products/by-type/?${params.toString()}`
  );
  return response.data;
};

/**
 * Obtener estadísticas de productos
 */
export const getStats = async (branch = null) => {
  // ✅ CORREGIDO: Usar el endpoint real de alertas de stock en ProductInventoryViewSet
  let url = "inventory/product-inventory/stock_alerts/";
  if (branch) url += `?branch=${branch}`;

  const response = await GET(url);
  return response.data;
};

export const bulkImport = async (file, branch = null) => {
  let url = "inventory/products/bulk_import/";
  if (branch) {
    url += `?branch=${branch}`;
  }

  const response = await POST_FORM(url, {
    file,
  });
  return response.data;
};

export const categories = {
  create: create_category,
  list: list_category,
  update: update_category,
  destroy: destroy_category,
};

/**
 * Validar disponibilidad de stock en tiempo real
 * @param {Array<{product_id: string, quantity: number}>} items - Lista de items a validar
 * @returns {Promise<{all_available: boolean, validations: Array, can_proceed: boolean}>}
 */
export const checkAvailability = async (items) => {
  const response = await POST("inventory/product-inventory/validate_stock_availability/", {
    items,
  });
  return response.data;
};
